import React, {  useState, useEffect } from "react";
import {  updateActiveStatus } from "../../services/user.services";
import {
  CCard,
  CCardBody,
  CCol,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CButton,
  CFormInput,
  CFormLabel,
} from "@coreui/react";
import CustomPagination from "../../components/CustomPagination";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import Switch from "react-switch";
import { getActiveCountryList } from "src/services/country.services";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { getVehicleList, updateVehicle } from "src/services/vehicle";
import CIcon from "@coreui/icons-react";
import { cilPlus } from "@coreui/icons";
import { department, licenseType } from "./static";

const VehicleManagementTable = () => {
  // const toaster = useRef();
  // const [toast, addToast] = useState("");
  const [localUser, setLocalUser] = useState(
    JSON.parse(localStorage.getItem("user"))
  );
  const [activeCountries, setActiveCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [countryData,setCountryData]=useState([]);
  const [defaultErrorMessage, setDefaultErrorMessage] = useState(
    '"Something went wrong. Please try again"'
  );

  const [filterSelectCountry, setFilterSelectCountry] = useState("");

  const { register, reset, getValues, handleSubmit } = useForm({
    defaultValues: {
      registerNo: "",
    },
  });

  useEffect(() => {
    if (localUser?.userType === "superAdmin") {
      getActiveCountries();
      getVehicleItem(currentPage);
    } else {
      getVehicleItem(currentPage);
    }
  }, [selectedCountry, currentPage]);

  const getVehicleItem = async(page, registerNo = null) => {
    setIsLoading(true);
    let params = getActiveParams(page, registerNo);
    try{
        const response= await getVehicleList(params)
        setData(response.data);
        setCount(response.count);
        setTotalPages(Math.ceil(response.count / limit));
        
    }catch(e){
        console.log(e)
        setData([])
        setTotalPages(0)
        setCount(0)
    }finally{
        setIsLoading(false)
    }
  };

  //get all active countries
  const getActiveCountries = () => {
    getActiveCountryList({ limit: 100, page: 1, status: true })
      .then((response) => {
        if (response.success && response.data) {
          setActiveCountries(response?.data ?? []);
        }
      })
      .catch((error) => console.log(error));
  };

  const handleStatusChange = async (checked, id) => {
    const payload = {
      isActive: checked,
    };
    toast.loading("Updating Vehicle...", { id: "update-vehicle" }); 
    const response = await updateVehicle(payload, id);
    toast.dismiss("update-vehicle");
    if(response.success){
      toast.success("Vehicle updated successfully");
      let newData = [...data];
      newData = newData.map((item) => {
        if (item._id === id) {
          item.isActive = checked;
        }
        return item;
      })
      setData(newData);
    }else{
      toast.error("Something went wrong");
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    getVehicleItem(newPage);
  };

  const onFormSubmit = (data) => {
    setCurrentPage(1);
    
    getVehicleItem(1, data);
  };
  const handleReset = () => {
    reset({
      name: "",
      email: "",
      country: "",
      type: "",
      isActive: "",
      registerNo: "",
    });
    setSelectedCountry("");
    setCurrentPage(1);
    getVehicleItem(1);
  };

  const getActiveParams = (page, searchData) => {
    let params = {
      limit,
      page,
      ...getValues(),
    };
    
    if (selectedCountry) {
      params.region = selectedCountry._id;
    }
     if (searchData?.registerNo) {
      params.registrationNo = searchData?.registerNo;
    }
    console.log(params,"params")
    return params;
  };

  const handleSelectChange = (e,setMethod,property,region) => {
    setMethod(e);

    if(e?.[region??'value']){
      setError(property, null);
    }
  };

  const getCountryList=async()=>{
      const response = await getActiveCountryList({limit:20,page:1});
      const countries  = response?.data;
      console.log("countries",countries)
      setCountryData(countries);
  }

  useEffect(()=>{
    getCountryList()
  },[])

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <div className="position-absolute p-2 top-0 end-0">
            {/* <CButton
              type="button"
              size="sm"
              className="bg-none"
              color="primary"
              onClick={() => setShowAdditionalFields((prev) => !prev)}
            >
              {showAdditionalFields ? (
                <BsChevronDoubleUp size={15} />
              ) : (
                <BsChevronDoubleDown size={15} />
              )}
            </CButton> */}
          </div>
          <CRow className="mb-4">
            <CCol xs={12} md={3}>
                <CFormLabel>Select Country</CFormLabel>
                <Select
                    value={selectedCountry}
                    onChange={(e) => handleSelectChange(e, setSelectedCountry,"_id")}
                    options={activeCountries}
                    getOptionLabel={(option) => option?.name}
                    getOptionValue={(option) => option?._id}
                    isClearable={true}
                    placeholder="Select Country"
                    isDisabled={
                      !activeCountries && activeCountries?.length <= 0 ? true : false
                    }
                  />
            </CCol>
            <CCol xs={12} md={3}>
              <CFormLabel>Registration No</CFormLabel>
              <CFormInput
                type="text"
                placeholder="Type Registration No"
                {...register("registerNo", { required: false })}
              />
            </CCol>
          </CRow>


          <div className="d-flex justify-content-end mt-3">
            <CButton
              type="submit"
              color="primary"
              className="px-5 py-2 me-3"
              onClick={handleSubmit(onFormSubmit)}
            >
              Submit
            </CButton>
            <CButton
              type="submit"
              className="px-5 py-2 ms-3 btn-oliveGreen"
              onClick={handleReset}
            >
              Reset
            </CButton>
          </div>
        </CCardBody>
      </CCard>
      <CCard className="mb-4">
        <CCardBody>
          <CRow className="justify-content-between">
            <CCol sm={5}>
              <h4 id="traffic" className="card-title mb-0">
                Vehicle Management - Total: {count}
              </h4>
            </CCol>
            <CCol xs={2}>
              <Link to="/create-vehicle">
                <CButton style={{ width: "100%" }}>
                  <CIcon icon={cilPlus} />
                  &nbsp; Create
                </CButton>
              </Link>
            </CCol>
          </CRow>
          <br />
          <CTable
            align="middle"
            className="mb-0 border text-center"
            hover
            responsive
          >
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell className="text-center">
                  Active Status
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Action
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Vehicle Id
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Device Id
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Max Speed
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  License Type
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Purchase Amount
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Region
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Registration No
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Sim Card
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Mileage
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Fuel Type 
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Vehicle Type
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Department
                </CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {isLoading ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="9">Loading...</CTableDataCell>
                </CTableRow>
              ) : data.length == 0 ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="9">No data available</CTableDataCell>
                </CTableRow>
              ) : (
                data.map((item, index) => (
                  <CTableRow v-for="item in tableItems" key={index}>
                    <CTableDataCell>
                      <Switch
                        onChange={(checked, id) =>
                          handleStatusChange(checked, item._id)
                        }
                        checked={item.isActive}
                      />
                    </CTableDataCell>
                    <CTableDataCell>
                      <Link to={`/edit-vehicle/${item._id}`}>
                        <CButton color="secondary" style={{ color: "white" }}>
                          <FaEdit />
                        </CButton>
                      </Link>
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      <div>
                        {item?.vehicleId}
                      </div>
                    </CTableDataCell>
                    <CTableDataCell>{item.deviceId}</CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item?.maxSpeed}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                        {licenseType.find((type) => type.value === item.drivingLicenseType)?.label}
                    </CTableDataCell>
                    <CTableDataCell>{item.purchaseAmount}</CTableDataCell>
                    <CTableDataCell>{countryData?.find((type) => type._id === item.region)?.name}
                      {console.log(countryData,"countryData")}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item?.registrationNo}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item?.simCardNumber}
                    </CTableDataCell> 
                    <CTableDataCell className="text-capitalize">
                      {item?.mileage}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item?.fuelType}
                    </CTableDataCell>
                     <CTableDataCell className="text-capitalize">
                      {item?.vehicleType}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {department?.find((type) => type.value === item?.department)?.label}
                    </CTableDataCell>
                  </CTableRow>
                ))
              )}
            </CTableBody>
          </CTable>
          <br />
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </CCardBody>
      </CCard>

      {/* <CToaster ref={toaster} push={toast} placement="top-end" /> */}
    </>
  );
};

export default VehicleManagementTable;
